import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AssignmentReport.css";

const API_URL = "https://aadyaacademy.org/api";

function AssignmentReport() {
  const today = new Date().toISOString().split("T")[0];
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [filteredAssignments, setFilteredAssignments] = useState([]);
  const [loading, setLoading] = useState(true);

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const fetchClassSectionData = async () => {
    try {
      const [classRes, sectionRes] = await Promise.all([
        axios.get(`${API_URL}/classes`),
        axios.get(`${API_URL}/sections`),
      ]);
      setClasses(classRes.data?.classes || classRes.data || []);
      setSections(sectionRes.data?.sections || sectionRes.data || []);
    } catch (error) {
      console.error("Error fetching class/section data:", error);
    }
  };

  const fetchAssignments = async (date) => {
    try {
      setLoading(true);
      const teacherPhone = localStorage.getItem("userPhone");

      const res = await axios.get(`${API_URL}/teacher-assignment-reports`, {
        params: {
          phone: teacherPhone,
          date: date,
        },
      });

      const data = res.data?.assignment_summary || [];
      const formatted = data.map((item, index) => ({
        id: index + 1,
        class: item.class,
        section: item.section,
        date: item.date,
        status: item.status,
      }));

      const sortedAssignments = formatted.sort(
        (a, b) => parseInt(a.class) - parseInt(b.class)
      );

      setAssignments(sortedAssignments);
      setFilteredAssignments(sortedAssignments);
    } catch (error) {
      console.error("Error fetching assignments:", error);
      setAssignments([]);
      setFilteredAssignments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClassSectionData();
  }, []);

  useEffect(() => {
    if (selectedDate) {
      fetchAssignments(selectedDate);
    } else {
      setAssignments([]);
      setFilteredAssignments([]);
    }
  }, [selectedDate]);

  useEffect(() => {
    let filtered = [...assignments];

    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item.class.toLowerCase().includes(search) ||
          item.section.toLowerCase().includes(search)
      );
    }

    if (selectedClass) {
      filtered = filtered.filter((item) => item.class === selectedClass);
    }

    if (selectedSection) {
      filtered = filtered.filter((item) => item.section === selectedSection);
    }

    filtered = filtered.sort((a, b) => parseInt(a.class) - parseInt(b.class));

    setFilteredAssignments(filtered);
  }, [searchTerm, selectedClass, selectedSection, assignments]);

  return (
    <div className="assignment-report">
      <div className="table-header">
        <h3>Assignment Report</h3>
        <div className="table-header-btm">
          <input
            type="date"
            className="date-picker"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
          <select
            className="class-filter"
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
          >
            <option value="">All Classes</option>
            {classes
              .sort((a, b) => parseInt(a.name || a) - parseInt(b.name || b))
              .map((cls, i) => (
                <option key={i} value={cls.name || cls}>
                  {cls.name || cls}
                </option>
              ))}
          </select>
          <select
            className="section-filter"
            value={selectedSection}
            onChange={(e) => setSelectedSection(e.target.value)}
          >
            <option value="">All Sections</option>
            {sections.map((section, i) => (
              <option key={i} value={section.name || section}>
                {section.name || section}
              </option>
            ))}
          </select>
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th className="thead-content">Class</th>
              <th className="thead-content">Section</th>
              <th className="thead-content">Date</th>
              <th className="thead-content">Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssignments.length > 0 ? (
              filteredAssignments.map((item) => (
                <tr key={item.id}>
                  <td className="tbody-content">{item.class}</td>
                  <td className="tbody-content">{item.section}</td>
                  <td className="tbody-content">{formatDate(item.date)}</td>
                  <td className="tbody-content">
                    <span
                      className={`status-badge ${
                        item.status === "Given" ? "submitted" : "not-submitted"
                      }`}
                    >
                      {item.status === "Given" ? "Submitted" : "Not Submitted"}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="tbody-content">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AssignmentReport;
